import { render } from "./product-header.vue?vue&type=template&id=24c28dd4"
import script from "./product-header.vue?vue&type=script&lang=js"
export * from "./product-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__